// API related actions

// complementary actions
export const LOADING_EXCEL_DATA = '@@toyota/LOADING_EXCEL_DATA';
